import ShippingAddressForm from './shipping-address-form.jsx'

export default ShippingAddressForm
